/**
 * Alert — Banner/alerta inline com dark theme
 */
import type { JSX } from 'preact';
import { T } from '../../styles/tokens';

type AlertType = 'info' | 'success' | 'warning' | 'error';

interface AlertProps {
  type?: AlertType;
  title?: string;
  children: any;
  onClose?: () => void;
  icon?: any;
  style?: JSX.CSSProperties;
}

const cores: Record<AlertType, { border: string; bg: string; icon: string }> = {
  info: { border: T.primary, bg: T.primaryBg, icon: 'ℹ' },
  success: { border: T.success, bg: T.successBg, icon: '✓' },
  warning: { border: T.warning, bg: T.warningBg, icon: '⚠' },
  error: { border: T.danger, bg: T.dangerBg, icon: '✕' },
};

export function Alert({ type = 'info', title, children, onClose, icon, style }: AlertProps) {
  const c = cores[type];

  return (
    <div style={{
      display: 'flex',
      gap: T.space3,
      padding: T.space4,
      background: c.bg,
      borderLeft: `3px solid ${c.border}`,
      borderRadius: T.radiusMd,
      fontSize: T.textSm,
      color: T.text,
      ...style,
    }}>
      <span style={{ color: c.border, fontSize: T.textLg, flexShrink: 0, lineHeight: 1.2 }}>
        {icon || c.icon}
      </span>
      <div style={{ flex: 1 }}>
        {title && (
          <div style={{ fontWeight: T.weightSemibold, marginBottom: T.space1 }}>{title}</div>
        )}
        <div style={{ color: T.textSecondary, lineHeight: 1.5 }}>{children}</div>
      </div>
      {onClose && (
        <button
          onClick={onClose}
          style={{
            background: 'none', border: 'none', cursor: 'pointer',
            color: T.textMuted, padding: 2, fontSize: 14, lineHeight: 1,
            flexShrink: 0, alignSelf: 'flex-start',
          }}
        >
          ✕
        </button>
      )}
    </div>
  );
}
